import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { position, space, display } from 'styled-system';
import { colors } from '@styles/theme';

import HotelStyleSvg from '@components/svg/HotelStyleSvg';
import DeepCleanSvg from '@components/svg/DeepCleanSvg';
import MoveOutSvg from '@components/svg/MoveOutSvg';

import BackSvg from '@assets/svg/back.svg';
import BackwardSvg from '@assets/svg/backward.svg';
import ForwardSvg from '@assets/svg/forward.svg';
import RightArrowSVG from '@assets/svg/right-arrow.svg';
import RecurringSvg from '@assets/svg/cleanRecurringXLarge.svg';
import SingleSvg from '@assets/svg/cleanOnceXLarge.svg';
import FridgeSVG from '@assets/svg/addOnFridgeXLarge.svg';
import LaundrySVG from '@assets/svg/addOnLaundryXLarge.svg';
import WindowSVG from '@assets/svg/addOnWindowsXLarge.svg';
import OvenSVG from '@assets/svg/addOnOvenXLarge.svg';
import MoppingSVG from '@assets/svg/addOnMoppingXLarge.svg';
import BathtubSVG from '@assets/svg/addOnBathtubXLarge.svg';
import LeafSVG from '@assets/svg/leaf.svg';
import CalendarSVG from '@assets/svg/calendar.svg';
import HugeLogo from '@assets/svg/minteLogoHuge.svg';
import MinteLogoSVG from '@assets/svg/minteLogoLarge.svg';
import CloseSVG from '@assets/svg/closeRegular.svg';
import MyAccountSVG from '@assets/svg/myAccountLarge.svg';
import SupportSVG from '@assets/svg/supportLarge.svg';
import LockSVG from '@assets/svg/lockSmall.svg';
import TimeAllDaySVG from '@assets/svg/timeAllDayRegular.svg';
import TimeMorningSVG from '@assets/svg/timeMorningRegular.svg';
import TimeAfternoonSVG from '@assets/svg/timeAfternoonRegular.svg';

// TODO: check Image component and allow customization
function SvgIcon(props) {
  const { name, zIndex, ...restProps } = props; // eslint-disable-line

  switch (name) {
    case 'logo':
      return <HugeLogo {...restProps} />;
    case 'minte-logo':
      return <MinteLogoSVG viewBox="0 0 32 38" {...restProps} />;
    case 'back':
      return <BackSvg viewBox="0 0 16 12" {...restProps} />;
    case 'backward':
      return <BackwardSvg viewBox="0 0 14 24" {...restProps} />;
    case 'forward':
      return <ForwardSvg viewBox="0 0 14 24" {...restProps} />;
    case 'deep-clean':
      return <DeepCleanSvg viewBox="0 0 48 48" {...restProps} />;
    case 'recurring-occurence':
      return <RecurringSvg viewBox="0 0 48 48" {...restProps} />;
    case 'single-occurence':
      return <SingleSvg viewBox="0 0 48 48" {...restProps} />;
    case 'hotel-style':
      return <HotelStyleSvg viewBox="0 0 48 48" {...restProps} />;
    case 'move-out':
      return <MoveOutSvg viewBox="0 0 48 48" {...restProps} />;
    case 'laundry-clean':
      return <LaundrySVG viewBox="0 0 48 48" {...restProps} />;
    case 'right-arrow':
      return <RightArrowSVG viewBox="0 0 20 28" {...restProps} />;
    case 'fridge-clean':
      return <FridgeSVG viewBox="0 0 48 48" {...restProps} />;
    case 'window-clean':
      return <WindowSVG viewBox="0 0 48 48" {...restProps} />;
    case 'oven-clean':
      return <OvenSVG viewBox="0 0 48 48" {...restProps} />;
    case 'mopping-clean':
      return <MoppingSVG viewBox="0 0 48 48" {...restProps} />;
    case 'bathroom-clean':
      return <BathtubSVG viewBox="0 0 24 24" {...restProps} />;
    case 'leaf':
      return <LeafSVG viewBox="0 0 14 14" {...restProps} />;
    case 'calendar':
      return <CalendarSVG viewBox="0 0 18 20" {...restProps} />;
    case 'close-circle':
      return <CloseSVG viewBox="0 0 24 24" {...restProps} />;
    case 'my-account':
      return <MyAccountSVG viewBox="0 0 32 32" {...restProps} />;
    case 'support':
      return <SupportSVG viewBox="0 0 32 32" {...restProps} />;
    case 'lock':
      return <LockSVG viewBox="0 0 16 16" {...restProps} />;
    case 'morning':
      return <TimeMorningSVG viewBox="0 0 25 24" {...restProps} />;
    case 'afternoon':
      return <TimeAfternoonSVG viewBox="0 0 25 24" {...restProps} />;
    case 'anytime':
      return <TimeAllDaySVG viewBox="0 0 25 24" {...restProps} />;
    default:
  }

  return null;
}

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.string
};

function getFillColor(props) {
  const { color } = props;

  if (!colors[color]) {
    return '';
  }

  return {
    fill: colors[color]
  };
}

// ${props => getFillColor(props)}

const steyldSVG = styled(SvgIcon)`
  ${position};
  ${space};
  ${display}

  path:last-child {
    ${props => getFillColor(props)}
  }
`;

export default steyldSVG;
